import { View } from 'react-native'
import { useTheme } from 'react-native-paper'
import { StyleSheet } from 'react-native-unistyles'

import SaveStatus from '@/components/shared/SaveStatus'
import UniButton from '@/components/unistyles/UniButton'
import UserService from '@/services/userService'

const UserDetailHeaderContent = () => {
  const theme = useTheme()
  const deactivateMutation = UserService.useDeactivateMutation()
  const { user, currentOrganization } = UserService.useUser()
  const isSaving = UserService.useIsSaving()

  const onDeactivate = () => {
    if (!user) return
    deactivateMutation.mutate({
      id: user.id,
      organizationId: currentOrganization?.id ?? '',
    })
  }

  return (
    <View style={styles.root}>
      {!user?.deactivatedAt && (
        <UniButton
          disabled={deactivateMutation.isPending}
          loading={deactivateMutation.isPending}
          onPress={onDeactivate}
          textColor={theme.colors.error}
        >
          Deactivate
        </UniButton>
      )}
      <SaveStatus
        isSaving={isSaving}
        updatedAt={user?.updatedAt}
        updatedBy={user?.updatedBy?.firstName + ' ' + user?.updatedBy?.lastName}
      />
    </View>
  )
}

const styles = StyleSheet.create((theme) => ({
  root: {
    alignItems: 'center',
    flexDirection: 'row',
    gap: theme.tokens.spacing[2],
  },
}))

export default UserDetailHeaderContent
